import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { routes } from '../config/utility';
import { StatsCard } from '../components/StatsCard';

const Order = () => {
    // Sample data for the table
    const data = [
        {
            walker: 'Md Khalid',
            client: 'Ahmed',
            dog: 'Boxer, Ruby',
            startTime: '03:30 PM',
            estEndTime: '03:30 PM',
            location: 'Abu Dhabi',
        },
        {
            walker: 'Sanawwar',
            client: 'Shakir',
            dog: 'Boxer, Ruby',
            startTime: '03:30 PM',
            estEndTime: '03:30 PM',
            location: 'Abu Dhabi',
        },
        {
            walker: 'Bilal',
            client: 'Anum',
            dog: 'Boxer, Ruby',
            startTime: '03:30 PM',
            estEndTime: '03:30 PM',
            location: 'Abu Dhabi',
        },
        // Add more rows as needed
    ];

    return (
        <div className=" min-h-screen p-8">
            {/* Tabs Section */}
            <div className="flex justify-between items-center mb-6">
                {/* Heading Section */}
                <h1 className="text-[#3E358F] text-3xl font-bold">Orders Overview</h1>

                {/* Tab Buttons Section */}
                <div className="flex space-x-4">
                    <button className="bg-[#3E358F] text-white px-8 py-3 rounded-full font-semibold shadow-md">
                        Ongoing Orders
                    </button>
                    <button className="bg-[#E6E3F6] text-[#5F558B] px-8 py-3 rounded-full font-semibold shadow-md">
                        New Orders
                    </button>
                    <button className="bg-[#E6E3F6] text-[#5F558B] px-8 py-3 rounded-full font-semibold shadow-md">
                        Order History
                    </button>
                </div>
            </div>

            {/* Stats Section */}
            <div className="grid grid-cols-3 gap-6 mb-12">
                <StatsCard title="Order" value="25k" />
                <StatsCard title="Cancelled" value="25k" />
                <StatsCard title="Viewed" value="25k" />
            </div>

            {/* Table Section */}
            <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                <table className="min-w-full table-auto">
                    <thead className="bg-purple-600 text-white">
                        <tr>
                            <th className="py-6 px-4 text-left">Walker Name</th>
                            <th className="py-6 px-4 text-left">Client Name</th>
                            <th className="py-6 px-4 text-left">Dog Name & Breed</th>
                            <th className="py-6 px-4 text-left">Start Time</th>
                            <th className="py-6 px-4 text-left">EST End Time</th>
                            <th className="py-6 px-4 text-left">Location</th>
                            <th className="py-6 px-4 text-left">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index} className="border-t text-gray-700">
                                <td className="px-4 py-2">
                                    <p>{row.walker}</p>
                                    <div className="text-sm space-x-2 text-blue-600">
                                    <Link to={`${routes.order_detail.replace(':id?', '1')}`}>View</Link>
                                        <a href="#" className="text-orange-500">Edit</a>
                                        <a href="#" className="text-red-600">Delete</a>
                                    </div>
                                </td>
                                <td className="px-4 py-2">{row.client}</td>
                                <td className="px-4 py-2">{row.dog}</td>
                                <td className="px-4 py-2">{row.startTime}</td>
                                <td className="px-4 py-2">{row.estEndTime}</td>
                                <td className="px-4 py-2">{row.location}</td>
                                <td className="px-4 py-2">
                                    <button className="bg-gray-200 px-3 py-2 rounded-lg">
                                        <FontAwesomeIcon icon={faChevronDown} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination Section */}
            <div className="flex justify-between items-center mt-4 p-2">
                <span className="text-gray-500 text-sm">Showing 1 to 1 of 1 Entries</span>
                <div className="flex space-x-2">
                    <button className="bg-gray-200 px-4 py-2 rounded-lg text-gray-700">Previous</button>
                    <span className="bg-black text-white px-4 py-2 rounded-lg">01</span>
                    <button className="bg-gray-200 px-4 py-2 rounded-lg text-gray-700">Next</button>
                </div>
            </div>
        </div>
    );
};

export default Order;
